import { ModelBase } from 'store/model-base';

export class NowPortOutSendPin extends ModelBase {
    public static storeName: string = 'nowPortOutSendPin';

    public notificationStatus: string;
    public isSuccess: boolean;


    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowPortOutSendPin = super.create<NowPortOutSendPin>(initData);
        toReturn.isSuccess = toReturn.notificationStatus === 'SUCCESS';

        return super.create<T>(toReturn);
    }
}
